<template lang="pug">
v-container(fluid)
  auth-modal(
    available
    style="position: absolute; left: -2000px; top: 0px;"
    @check-key="checkAuth()"
    @closed="$router.push('/')"
    )
  v-dialog(
    v-model="minorSalesModal"
    v-if="minorSales"
    )
    v-toolbar.primary(dark)
      span.title Ingreso Ventas Menores
    v-card.px-4.pb-2
      .d-flex.justify-space-between.py-2
        span.subheading.font-weight-bold
          | Ventas menores del día: {{minorSales.quantity}} 
        span.subheading.font-weight-bold.text-xs-right
          | Monto total ventas menores del día: 
          | {{minorSales.total | mixFormatCurrency}}
      v-text-field(
        mask="##################"
        @keydown.enter="registerMinorSales"
        outline
        v-model="minorSalesNumber"
        label="N°Boleta"
        ref="ticket_number"
        :color="colors.primary"
        )
      span.caption Debe generar una boleta manual por 
        | {{minorSales.total | mixFormatCurrency}} 
        | y anotar aquí el número de boleta
  .rendition-area(
    v-if="showRendition"
    )
    v-card.pa-4
     v-layout(wrap)
       v-flex.xs4 N° Caja: {{cashDeskID}}
       v-flex.xs4 Sucursal: {{branchOfficeName}}
       v-flex.xs4 Cajero Apertura: {{openingUser}}
       v-flex.xs4 Fecha Apertura: {{openingDate}}
       v-flex.xs4 Hora Apertura: {{openingTime}}
       v-flex.xs4 Monto Apertura: {{openingAmount | mixFormatCurrency}}
       v-flex.xs12 
        DateField(
          label="fecha"
          v-model="date"
          )
    v-stepper.mt-2(v-model="step")
      v-stepper-header
        v-stepper-step(:complete="step > 1" step="1") Conteo Efectivo
        v-divider
        v-stepper-step(:complete="step > 2" step="2") Cuadratura
      v-stepper-items
        v-stepper-content(step="1")
          h1.title Conteo de Efectivo
          v-layout(wrap)
            v-flex.xs4.text-row.primary.white--text
              span FORMATO
            v-flex.xs4.text-row.primary.white--text.font-weight-bold
              span CANTIDAD
            v-flex.xs4.text-row.primary.white--text.font-weight-bold
              span MONTO
            template(
              v-for="bill in billCounter"
              )
              v-flex.xs4.text-row.body-2(style="border-bottom: 1px solid #eee;") {{bill.name}}
              v-flex.xs4.input-row
                IntegerInput(
                  v-model="bill.quantity"
                  @input="updateBill"
                  @blur="() => !bill.quantity ? bill.quantity = 0: ''"
                  solo
                  :ref="bill.backendName + '-input'"
                  :readonly="loading || !newRendition"
                  )
              v-flex.xs4.input-row 
                IntegerInput(
                  v-model="bill.amount"
                  readonly
                  tabindex="-1"
                  solo
                  prefix="$ "
                  )
            v-flex.xs4.text-row.text-row.body-2.blue-grey.lighten-4
              span Cierre de Caja
            v-flex.xs4.text-row.blue-grey.lighten-4
            v-flex.xs4.text-row.body-2.blue-grey.lighten-4
              span {{realCashTotal | mixFormatCurrency}}
          v-layout(wrap)
            v-flex.xs3.offset-xs9.pt-3
              v-btn.primary(
                block
                @click="step = 2"
                ) SIGUIENTE
                v-icon(right) keyboard_arrow_right 
        v-stepper-content(step="2")
          h1.title Cuadratura
          v-layout(wrap)
            v-flex.xs3.text-row.primary.white--text.font-weight-bold CUADRATURA
            v-flex.xs3.text-row.primary.white--text.font-weight-bold SISTEMA
            v-flex.xs3.text-row.primary.white--text.font-weight-bold CAJERO
            v-flex.xs3.text-row.primary.white--text.font-weight-bold DIFERENCIA
            template(
              v-for="item in quadrature"
              )
              v-flex.xs3.text-row.body-2(
                style="border-bottom: 1px solid #eee;"
                :class="item.diff_amount < 0 ? ['red', 'lighten-4'] : []"
                ) {{item.name}}
              v-flex.xs3.input-row
                IntegerInput(
                  v-model="item.system_amount"
                  solo
                  readonly
                  prefix="$ "
                  )
              v-flex.xs3.input-row
                IntegerInput(
                  v-model="item.cashier_amount"
                  :readonly="loading || !newRendition || item.readonly"
                  solo
                  @input="updateQuadrature"
                  prefix="$ "
                  )
              v-flex.xs3.input-row
                IntegerInput(
                  v-model="item.diff_amount"
                  solo
                  readonly
                  prefix="$ "
                  )
            v-flex.xs3.text-row.text-row.body-2.blue-grey.lighten-4
              span Diferencia de Caja
            v-flex.xs6.text-row.blue-grey.lighten-4
            v-flex.xs3.text-row.body-2.blue-grey.lighten-4
              span(
                :class="totalDiff < 0 ? ['red--text'] : []"
                ) {{totalDiff | mixFormatCurrency}}
          h1.title.mt-4 Detalle Ventas
          v-layout(wrap)
            v-flex.xs3.text-row.primary.white--text.font-weight-bold RESUMEN
            v-flex.xs2.text-row.primary.white--text.font-weight-bold 
              v-btn.primary(
                block
                depressed
                @click="showTicketReport()"
                )
                span(style="font-size: 20px;") BOLETA
                v-icon(right).white--text add
            v-flex.xs2.text-row.primary.white--text.font-weight-bold 
              v-btn.primary(
                block
                depressed
                @click="showInvoiceReport()"
                )
                span(style="font-size: 20px;") FACTURA
                v-icon(right).white--text add
            v-flex.xs2.text-row.primary.white--text.font-weight-bold 
              v-btn.primary(
                block
                depressed
                @click="showPaymentReport()"
                )
                span(style="font-size: 20px;") PAGOS CLIENTE
                v-icon(right).white--text add
            v-flex.xs3.text-row.primary.white--text.font-weight-bold TOTALES
            template(v-for="item in saleDetails")
              v-flex.xs3.text-row.body-2(
                style="border-bottom: 1px solid #eee;"
                :class="item.isEmployee ? ['grey', 'lighten-2'] : []"
                ) {{item.name}}
              v-flex.xs2.input-row
                IntegerInput(
                  v-model="item.ticket"
                  prefix="$ "
                  solo
                  readonly
                  )
              v-flex.xs2.input-row
                IntegerInput(
                  v-model="item.invoice"
                  prefix="$ "
                  solo
                  readonly
                  )
              v-flex.xs2.input-row
                IntegerInput(
                  v-model="item.customer_debt"
                  prefix="$ "
                  solo
                  readonly
                  )
              v-flex.xs3.input-row
                IntegerInput(
                  v-model="item.total"
                  prefix="$ "
                  solo
                  readonly
                  )
            v-flex.xs12.pt-3
              v-btn.primary(
                @click="showCreditNoteReport"
                ) 
                span DETALLE NOTAS DE CRÉDITO
                v-icon add
              v-btn.info(
                @click="showAllCreditNoteReport"
                ) 
                span TODAS NOTAS DE CRÉDITO
                v-icon add
          h1.title.mt-4 Movimientos
          v-layout(wrap)
            v-flex.xs4.text-row.primary.white--text.font-weight-bold MOVIMIENTOS
            v-flex.xs4.text-row.primary.white--text.font-weight-bold CANTIDAD
            v-flex.xs4.text-row.primary.white--text.font-weight-bold TOTAL
            template(v-for="item in saleMovements")
              v-flex.xs4.text-row.body-2(
                style="border-bottom: 1px solid #eee;"
                :class="item.diff_amount < 0 ? ['red', 'lighten-4'] : []"
                ) {{item.name}}
              v-flex.xs4.input-row
                IntegerInput(
                  v-model="item.quantity"
                  solo
                  readonly
                  )
              v-flex.xs4.input-row
                IntegerInput(
                  v-model="item.amount"
                  prefix="$ "
                  solo
                  readonly
                  )
            v-flex.xs4.text-row.text-row.body-2.blue-grey.lighten-4
              span Total
            v-flex.xs4.text-row.blue-grey.lighten-4
            v-flex.xs4.text-row.body-2.blue-grey.lighten-4
              span {{saleMovementTotal | mixFormatCurrency}}
          v-expansion-panel
            v-expansion-panel-content
              div.font-weight-bold(slot="header")
                span Detalle Movimientos
                v-progress-circular.ml-3(
                  v-if="loadingMovements"
                  indeterminate
                  size="18"
                  color="primary"
                  )
              v-card
                v-data-table(
                  :headers="movementDetailHeaders"
                  hide-actions
                  :items="movementDetails"
                  )               
                  template(
                    slot="items"
                    slot-scope="props"
                    )
                    td {{props.item.id}}
                    td {{props.item.type}}
                    td {{props.item.movementType}}
                    td {{props.item.date}}
                    td {{props.item.time}}
                    td {{parseInt(props.item.amount) | mixFormatCurrency}}
          h1.title.mt-4 Comentarios
          v-layout
            v-flex.xs12
              v-text-field(
                textarea
                v-model="observation"
                :readonly="loading || !newRendition"
                )
          v-layout(wrap)
            v-flex.xs3.pt-3
              v-btn.primary(
                block
                @click="step = 1"
                ) ANTERIOR
                v-icon(right) keyboard_arrow_left
            v-flex.xs3.offset-xs6.pt-3
              v-btn(
                :class="newRendition ? ['success'] : ['primary']"
                block
                @click="handleSubmitButton"
                ) {{newRendition ? 'ENVIAR' : 'DESCARGAR PDF'}}
                v-icon(right) {{newRendition ? 'save' : 'picture_as_pdf'}}


  // Document List Modal
  v-dialog(v-model="showReportModal")
    v-toolbar.primary(dark)
      span.title {{reportTitle}}
      .d-flex(
        v-if="activeReport === 0"
        style="padding-top: 20px;")
        v-radio-group(v-model="ticketsToShow" row)
          v-radio(
            color="white"
            label="Todo"
            :value="1")
          v-radio(
            color="white"
            label="Ventas"
            :value="2")
          v-radio(
            color="white"
            label="Ventas Empleado"
            :value="3")
    v-card.py-3
      v-text-field.mx-3(
        label="Buscar"
        outline
        v-model="reportFilter"
        )
      v-data-table.mx-3(
        :items="filteredReport"
        :headers="showedReport.headers"
        hide-actions
        )
        template(slot="items" slot-scope="props")
          tr(
            style="cursor: pointer"
            @click="fetchDetail(props.item)"
            )
            td(
              v-for="header in showedReport.headers"
              :key="header.text"
              ) {{props.item[header.show ? header.show : header.value]}}


  // Document Details Modal
  v-dialog(v-model="showDocumentModal")
    v-card.pa-4
      v-layout.mb-3(wrap v-if="detailData")
        v-flex.xs6
          span.subheading.font-weight-bold {{detailData.isInvoice ? 'Factura' : 'Boleta'}} 
            | N°{{detailData.number}}
        v-flex.xs6.text-xs-right
          span.subheading.font-weight-bold Fecha: {{detailData.date}}
        v-flex.xs3
          span.subheading.font-weight-bold(
            v-if="detailData.seller"
            ) Vendedor: {{detailData.seller}}
        v-flex.xs3
          span.subheading.font-weight-bold(
            v-if="detailData.cashDesk"
            ) Caja N° {{detailData.cashDesk}}
        v-flex.xs3.text-xs-right
          span.subheading.font-weight-bold(
            v-if="detailData.cashier"
            ) Cajero: {{detailData.cashier}}
        v-flex.xs3.text-xs-right
          span.subheading.font-weight-bold(
            v-if="detailData.customer"
            ) Cliente: {{detailData.customer}}
      v-data-table(
        style="border: 1px solid #ddd;"
        :headers="detailHeaders"
        v-if="activeDocument"
        :items="activeDocument.detail"
        hide-actions
        )
        template(slot="items" slot-scope="props")
          td {{props.item.wh_product.id}}
          td {{props.item.wh_product.name}}
          td {{parseFloat(props.item.quantity)}}
          td {{getItemPrice(props.item) | mixFormatCurrency}}
          td {{getItemDiscounts(props.item)}}
          td {{getItemTotal(props.item) | mixFormatCurrency}}
      v-layout.pt-4(wrap v-if="!!activeDocument")
        v-flex.xs3.subheading.font-weight-bold
          span Descuento Global: 
          span(
            v-if="activeDocument.global_discount_percentage"
            ) {{activeDocument.global_discount_percentage}} %
          span(
            v-else-if="activeDocument.global_discount_amount"
            ) $ {{activeDocument.global_discount_percentage}}
          span(v-else) '-'
        v-flex.xs3
        v-flex.xs3
        v-flex.xs3.text-xs-right
          span.subheading.font-weight-bold
            | Total: {{parseInt(activeDocument.total) | mixFormatCurrency}}
</template>

<script>
import Rendicion from './script.js'
export default Rendicion
</script>

<style lang="scss" scoped>
.input-row {
    height: 47px;
}
.text-row {
    height: 47px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 20px;
}
</style>
